<ng-container *ngIf="userresponsestatus == true; else noListItemTmpl">
  <div class="outer_div">
    <div class="mainsec">
      <div class="content">
        <img src="../../../../assets/Images/bannerlogo1.png" class="logo" />
      </div>
      <div class="content" *ngIf="merchantCode == 'M'">
        <img src="../../../../assets/Images/process.png" class="spin" />
      </div>

      <div class="content" *ngIf="merchantCode != 'M'">
        <div *ngIf="transactionStatus == 2">

          <img src="../../../../assets/Images/tick.png" class="timeicon" />
          <span>
            {{transactionStatus===0?'Pending':transactionStatus===1?'Proccessing':transactionStatus===2?'Success':transactionStatus===3?'Failed':transactionStatus===4?'In-process':'none'}}

          </span>
        </div>
        <div *ngIf="transactionStatus == 0 || transactionStatus == 3">
          <img src="../../../../assets/Images/error.png" class="timeicon" />
          <span>
            {{transactionStatus===0?'Pending':transactionStatus===1?'Proccessing':transactionStatus===2?'Success':transactionStatus===3?'Failed':transactionStatus===4?'In-process':'none'}}

          </span>
        </div>
        <div *ngIf="transactionStatus == 1 || transactionStatus == 4">
          <img src="../../../../assets/Images/process.png" class="timeicon" />
          <span>
            {{transactionStatus===0?'Pending':transactionStatus===1?'Proccessing':transactionStatus===2?'Success':transactionStatus===3?'Failed':transactionStatus===4?'In-process':'none'}}

          </span>
        </div>

        <div class="amountt">
          <span>Amount : {{totalAmount}} </span>
        </div>
        <div class="amount">
          <span>Invoice No. : {{eziPayReferenceId}}</span>
        </div>
        <div class="amount">
          <span>Date : {{entryDate|date}}</span>
        </div>
        <div class="amount">
          <span>Remark : {{remark}}</span>
        </div>
        <div class="amount">
          <span>Beneficiary No. : {{beneficiarynumber}}</span>
        </div>
        <div class="amount">
          <a href="https://ezipay.global/#/Go-on">Back To Home</a>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noListItemTmpl>
  <div class="outer_div">

    <div class="mainsec">
      <div class="content">
        <img src="../../../../assets/Images/bannerlogo1.png" class="logo" />
      </div>
      <div>
        <img src="../../../../assets/Images/process.png" class="timeicon" />
      </div>

      <div class="amount">
        <span>{{userresponsemsg}} </span>
      </div>
      <div class="amount" *ngIf="merchantCode != 'U'">
        <a href="https://ezipay.global/#/Go-on">Back To Home</a>
      </div>
    </div>
  </div>
</ng-template>




<style>
  .outer_div {
    border-style: solid;
    /*margin-right: 100px;
        position: absolute;*/
  }

  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*display: flex;
        justify-content: center;
        align-items: center;*/
  }

  .mainsec {
    border: 1px solid #e5dfdf;
    text-align: center;
    margin: auto;
    border-radius: 30px;
  }

  .logo {
    width: 210px;
    padding: 20px 0;
  }

  .amount {
    font-size: 25px;
    padding: 10px 0;
  }

  .timeicon {
    width: 50px;
    height: 50px;
    margin: 20px 0;
  }

  .msg {
    font-size: 30px;
    padding: 10px 0;
    color: gray;
    font-size: 20px;
  }

  .amountt {
    font-size: 30px;
    padding: 10px 0;
    color: steelblue;
  }
</style>



